import React from 'react';
import { X, User, Trophy, Building2 } from 'lucide-react';
import { formatters } from '../../utils/formatters';

const ClientListModal = ({ isOpen, onClose, clients, title, company = null }) => {
  if (!isOpen) return null;

  const totalPoints = clients.reduce((sum, client) => sum + (client.points || 0), 0);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 md:p-6 border-b">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-gray-800">{title}</h2>
            {company && (
              <p className="text-sm text-gray-600 mt-1">
                Empresa: {company.name}
              </p>
            )}
            <div className="flex items-center gap-2 md:gap-4 mt-2 text-sm text-gray-600 flex-wrap">
              <span className="flex items-center gap-1">
                <User className="w-4 h-4" />
                {clients.length} cliente{clients.length !== 1 ? 's' : ''}
              </span>
              <span className="flex items-center gap-1">
                <Trophy className="w-4 h-4" />
                {totalPoints} pontos totais
              </span>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 md:p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          {clients.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              <User className="w-12 h-12 mx-auto mb-4 text-gray-300" />
              <p>Nenhum cliente encontrado</p>
            </div>
          ) : (
            <div className="space-y-3">
              {clients.map((client) => (
                <div key={client.id} className="flex flex-col md:flex-row md:items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors gap-3">
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <User className="w-5 h-5 text-blue-600" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <h4 className="font-medium text-gray-900 truncate">{client.name}</h4>
                        <p className="text-sm text-gray-600">
                          CPF/CNPJ: {formatters.formatCpfOrCnpj(client.cpf)}
                        </p>
                        {client.birthDate && (
                          <p className="text-sm text-gray-600">
                            Nascimento: {formatters.formatDate(client.birthDate)}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="text-right flex-shrink-0">
                    <div className="flex items-center gap-2 mb-1 justify-end">
                      <Trophy className="w-4 h-4 text-yellow-600" />
                      <span className="font-bold text-lg text-gray-900">
                        {client.points || 0}
                      </span>
                      <span className="text-sm text-gray-600">pontos</span>
                    </div>
                    {!company && client.companyName && (
                      <div className="flex items-center gap-1 text-sm text-gray-600 justify-end">
                        <Building2 className="w-3 h-3" />
                        <span className="truncate max-w-[120px]">{client.companyName}</span>
                      </div>
                    )}
                    <p className="text-xs text-gray-500">
                      Cadastrado em {formatters.formatDate(client.createdAt)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t bg-gray-50">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-600">
              Total: <span className="font-medium">{clients.length} cliente{clients.length !== 1 ? 's' : ''}</span> · 
              <span className="font-medium ml-1">{totalPoints} pontos</span>
            </div>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientListModal;
